import { isFloatMatch } from '@impuls-coach/util-is';
import { ValidationError } from 'components/hoc/withValidation';
import i18n from 'helper/i18n';
import { sanitizeFloat } from 'helper/sanitize';
import { VALIDATE_IS_NOT_ALLOWED } from 'helper/validator';

const settings = {
	overallMin: 20,
	overallMax: 200,
};

export default function weightValidatorFactory(inputValue: string): Promise<ValidationError | undefined> {
	return new Promise((resolve: Function, reject: Function) => {
		const toVerify: string = inputValue.toString();

		if (toVerify === '') {
			return reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.cardDetail.tracking.validationWeight.isRequired'),
			});
		}

		if (!isFloatMatch(toVerify)) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.cardDetail.tracking.validationWeight.invalidFormat'),
			});
			return;
		}

		const value = parseFloat(inputValue);

		if (value <= settings.overallMin) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.cardDetail.tracking.validationWeight.tooLow'),
			});
			return;
		}
		if (value > settings.overallMax) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.cardDetail.tracking.validationWeight.tooHigh'),
			});
			return;
		}

		resolve();
	});
}

export const sanitize = (value: string): string => {
	return sanitizeFloat(value, 3);
};
